// Each daily snapshot from the Metrics `monthly_snapshot` contract carries its own
// calendar periods (the backend decides which months are previous/current/next in
// America/Toronto — the browser timezone is never consulted). This module centralizes the
// period roles and the field names of the `scheduled`/`actual` value objects so every
// section reads the same keys. If the deployed backend names a field differently, change
// it here once rather than in each section.

export const PERIOD_ROLES = ['previous', 'current', 'next'];

// Roles that legitimately carry actuals. `next` has not started, so its `actual` object is
// null and must never be rendered as $0 / 0 hours.
export const ACTUAL_ROLES = ['previous', 'current'];

export const PERIOD_LABEL_EXPRESSIONS = {
  previous: 'metrics.ClientMetrics.SnapshotHeader.Previous',
  current: 'metrics.ClientMetrics.SnapshotHeader.Current',
  next: 'metrics.ClientMetrics.SnapshotHeader.Next',
};

// Metric keys shared by the `scheduled` and `actual` value objects within each period, as
// returned by the Metrics monthly_snapshot contract (client = billable side, caregiver =
// pay side). `goodDirection` drives variance chip tone; `optional` rows are hidden when
// both sides are missing (expenses are only present on the actual side).
export const OVERVIEW_METRICS = [
  {key: 'clientHours', kind: 'hours', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.ClientHours', goodDirection: 'up'},
  {key: 'clientWeightedHours', kind: 'hours', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.ClientWeightedHours', goodDirection: 'up'},
  {key: 'caregiverHours', kind: 'hours', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.CaregiverHours', goodDirection: 'up'},
  {
    key: 'caregiverWeightedHours',
    kind: 'hours',
    labelExpression: 'metrics.ClientMetrics.Overview.Metrics.CaregiverWeightedHours',
    goodDirection: 'up',
  },
  {key: 'revenue', kind: 'currency', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.Revenue', goodDirection: 'up'},
  {key: 'laborCost', kind: 'currency', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.LaborCost', goodDirection: 'down'},
  {key: 'grossProfit', kind: 'currency', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.GrossProfit', goodDirection: 'up'},
  {key: 'clientCount', kind: 'count', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.ClientCount', goodDirection: 'up'},
  {key: 'caregiverCount', kind: 'count', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.CaregiverCount', goodDirection: 'up'},
  {key: 'expenses', kind: 'currency', labelExpression: 'metrics.ClientMetrics.Overview.Metrics.Expenses', goodDirection: 'neutral', optional: true},
];

export const getPeriod = (snapshot, role) => {
  return snapshot?.periods?.[role] || null;
};

// The current period exposes its actual cut-off; take it straight from the backend rather
// than deriving "today" locally.
export const getThroughDate = (snapshot) => {
  return snapshot?.periods?.current?.actual?.throughDate || null;
};
